import { QuizField, QuizSelectField } from '../model/quiz-field';

/**
 * Type guard for checking quiz fields
 *
 * @param field Field to check
 *
 * @returns
 * `true`, if `field` is a quiz field
 */
export function isQuizField(field: Record<string, any>): field is QuizField {
  return field && (field instanceof QuizField || !!(field as QuizField)['key']);
}

/**
 * Type guard for checking quiz select fields
 *
 * @param field Field to check
 *
 * @returns
 * `true`, if `field` is a quiz select field
 */
export function isQuizSelectField(field: QuizField): field is QuizSelectField {
  return (
    !!field.widgetOptions &&
    (field.widgetOptions instanceof QuizField ||
      ('items' in field.widgetOptions &&
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        Array.isArray(field.widgetOptions['items'])))
  );
}
